import loadable from '@loadable/component';

// Template
import DashboardTemplate from '../../components/dashboard/DashboardTemplate';

const PATH = '/dashboard';

const dashboardRoutes = {
  name: 'dashboard.root',
  path: PATH,
  component: DashboardTemplate,
  query: require('../../components/dashboard/__generated__/DashboardTemplateQuery.graphql'),
  routes: [
    {
      name: 'dashboard',
      path: PATH,
      component: loadable(
        () => import('../../components/vacancies/CandidateVacancies'),
      ),
      exact: true,
      query: require('../../components/vacancies/__generated__/CandidateVacanciesQuery.graphql'),
      queriesParams: () => ({
        first: 100,
      }),
    },
    {
      name: 'dashboard.opportunities',
      path: `${PATH}/opportunities`,
      component: loadable(
        () => import('../../components/opportunities/OpportunitiesList'),
      ),
      exact: true,
      query: require('../../components/opportunities/__generated__/OpportunitiesListQuery.graphql'),
      queriesParams: () => ({ isPublicInternet: true }),
    },
    {
      name: 'dashboard.vacancies',
      path: `${PATH}/vacancies`,
      component: loadable(
        () => import('../../components/vacancies/CandidateVacancies'),
      ),
      exact: true,
      query: require('../../components/vacancies/__generated__/CandidateVacanciesQuery.graphql'),
      queriesParams: () => ({
        first: 100,
      }),
    },
    {
      name: 'dashboard.documents',
      path: `${PATH}/documents`,
      component: loadable(
        () => import('../../components/documents/list/Documents'),
      ),
      exact: true,
      query: require('../../components/documents/list/__generated__/DocumentsQuery.graphql'),
    },
    {
      name: 'dashboard.document',
      path: `${PATH}/documents/:id`,
      component: loadable(
        () => import('../../components/documents/form/DocumentForm'),
      ),
      exact: true,
      query: require('../../components/documents/form/__generated__/DocumentFormQuery.graphql'),
      queriesParams: ({ match: { params } }) => ({
        documentType: params.id,
        dependent: params.dependentId || null,
      }),
    },
    {
      name: 'dashboard.dependents',
      path: `${PATH}/dependents`,
      component: loadable(
        () => import('../../components/dependents/Dependents'),
      ),
      exact: true,
      query: require('../../components/dependents/__generated__/DependentsQuery.graphql'),
    },
    {
      name: 'dashboard.dependents.documents',
      path: `${PATH}/dependents/:id/documents`,
      component: loadable(
        () => import('../../components/dependents/DependentDocuments'),
      ),
      exact: true,
      query: require('../../components/dependents/__generated__/DependentDocuments_query.graphql'),
      queriesParams: ({ match: { params } }) => ({
        id: params.id,
      }),
    },
    {
      name: 'dashboard.dependent.document',
      path: `${PATH}/dependent/:dependentId/document/:id`,
      component: loadable(
        () => import('../../components/documents/form/DocumentForm'),
      ),
      exact: true,
      query: require('../../components/documents/form/__generated__/DocumentFormQuery.graphql'),
      queriesParams: ({ match: { params } }) => ({
        documentType: params.id,
        dependent: params.dependentId || null,
      }),
    },
    {
      name: 'dashboard.add.dependents',
      path: `${PATH}/dependents/add`,
      component: loadable(
        () => import('../../components/dependents/DependentAdd'),
      ),
      exact: true,
      query: require('../../components/dependents/__generated__/DependentAddQuery.graphql'),
    },
    {
      name: 'dashboard.edit.dependents',
      path: `${PATH}/dependent/:id`,
      component: loadable(
        () => import('../../components/dependents/DependentEdit'),
      ),
      exact: true,
      query: require('../../components/dependents/__generated__/DependentEditQuery.graphql'),
      queriesParams: (props) => ({ id: props.match.params.id }),
    },
    {
      name: 'dashboard.professional.info',
      path: `${PATH}/professional/info`,
      component: loadable(
        () => import('../../components/professional/CandidateJobExperiences'),
      ),
      exact: true,
      query: require('../../components/professional/__generated__/CandidateJobExperiencesQuery.graphql'),
      queriesParams: () => ({
        first: 10,
      }),
    },
    {
      name: 'dashboard.account',
      path: `${PATH}/account`,
      component: loadable(() => import('../../components/account/Account')),
      exact: true,
      query: require('../../components/account/__generated__/AccountQuery.graphql'),
    },
    {
      name: 'dashboard.messages',
      path: `${PATH}/messages`,
      component: loadable(
        () => import('../../components/vacancies/CandidateMessages'),
      ),
      exact: true,
      query: require('../../components/vacancies/__generated__/CandidateMessagesQuery.graphql'),
      queriesParams: () => ({
        first: 10,
      }),
    },
    {
      name: 'dashboard.exam',
      path: `${PATH}/vaga/:jobExamId/exame/:candidateApplicationId`,
      component: loadable(
        () =>
          import('../../components/jobs/jobExam/JobExamByCandidateApplication'),
      ),
      exact: true,
      query: require('../../components/jobs/jobExam/__generated__/JobExamByCandidateApplicationQuery.graphql'),
      queriesParams: (props) => ({
        jobExamId: props.match.params.jobExamId,
        candidateApplicationId: props.match.params.candidateApplicationId,
        isActive: true,
      }),
    },
    {
      name: 'dashboard.exam.detail',
      path: `${PATH}/prova/:jobExamId`,
      component: loadable(
        () => import('../../components/jobs/jobExam/JobExamDetail'),
      ),
      exact: true,
      query: require('../../components/jobs/jobExam/__generated__/JobExamDetailQuery.graphql'),
      queriesParams: ({ match: { params } }) => ({
        jobExamId: params.jobExamId,
      }),
    },
    {
      name: 'dashboard.groupInterviews',
      path: `${PATH}/groupInterviews`,
      component: loadable(
        () => import('../../components/groupInterview/GroupInterviewList'),
      ),
      exact: true,
      query: require('../../components/groupInterview/__generated__/GroupInterviewListQuery.graphql'),
      queriesParams: () => ({
        first: 100,
      }),
    },
    {
      name: 'dashboard.groupInterviewRooms',
      path: `${PATH}/groupInterview/:id`,
      component: loadable(
        () => import('../../components/groupInterview/GroupInterviewRoomList'),
      ),
      exact: true,
      query: require('../../components/groupInterview/__generated__/GroupInterviewRoomListQuery.graphql'),
      queriesParams: ({ match: { params } }) => ({
        groupInterview: params.id,
        first: 100,
      }),
    },
    {
      name: 'dashboard.scheduledInterviews',
      path: `${PATH}/scheduledInterviews/`,
      component: loadable(
        () => import('../../components/interview/ScheduledInterview'),
      ),
      exact: true,
      query: require('../../components/interview/__generated__/ScheduledInterviewQuery.graphql'),
      queriesParams: () => ({
        first: 100,
      }),
    },
  ],
};

export default dashboardRoutes;
